import { RootState } from 'store/index';

export const prop_certificates_getCertificates = (state: RootState) => state.prop_certificates.certificates;
export const prop_certificates_getCertificatesLoading = (state: RootState) =>
    state.prop_certificates.certificatesLoading;
export const prop_certificates_getCertificatesError = (state: RootState) => state.prop_certificates.certificatesError;
export const prop_certificates_getRenderByCertId = (state: RootState) => state.prop_certificates.renderByCertId;
export const prop_certificates_getShareLinkByCertId = (state: RootState) => state.prop_certificates.shareLinkByCertId;
export const prop_certificates_getSocialSharing = (state: RootState) => state.prop_certificates.socialSharing;
export const prop_certificates_getIsPayoutCertificationEnabled = (state: RootState) =>
    state.prop_certificates.isPayoutCertificationEnabled;
export const prop_certificates_getIsChallengePassCertificationEnabled = (state: RootState) =>
    state.prop_certificates.isChallengePassCertificationEnabled;
export const prop_certificates_getIsCertificationsEnabled = (state: RootState): boolean | undefined => {
    const isPayoutEnabled = prop_certificates_getIsPayoutCertificationEnabled(state);
    const isChallengePassEnabled = prop_certificates_getIsChallengePassCertificationEnabled(state);
    const isAnyTypeEnabled = isPayoutEnabled === true || isChallengePassEnabled === true;
    const isStateUnknown = isPayoutEnabled === undefined && isChallengePassEnabled === undefined;

    if (isAnyTypeEnabled) {
        return true;
    }

    if (isStateUnknown) {
        return undefined;
    }

    return false;
};
